<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option
      v-for="businessExecutive in selects"
      :key="businessExecutive.id"
      :value="businessExecutive.id"
      :selected="businessExecutive.id === selected"
      >{{ businessExecutive.name }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectBusinessExecutive',
  data() {
    return {
      firstOption: this.first ? this.first : 'Selecione um executivo',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/business-executive/all`).then((res) => (this.selects = res.data));
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
